export default __webpack_public_path__ + "static/graphic_exec-functioning_small-6d78db3d2a28a0177184762241c7d811.png";